import { render } from "./BoardSimpleRank4.vue?vue&type=template&id=bdaf930a&scoped=true"
import script from "./BoardSimpleRank4.vue?vue&type=script&lang=js"
export * from "./BoardSimpleRank4.vue?vue&type=script&lang=js"

import "./BoardSimpleRank4.vue?vue&type=style&index=0&id=bdaf930a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdaf930a"],['__file',"src/components/h5/board/BoardSimpleRank4.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bdaf930a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bdaf930a', __exports__)) {
    api.reload('bdaf930a', __exports__)
  }
  
  module.hot.accept("./BoardSimpleRank4.vue?vue&type=template&id=bdaf930a&scoped=true", () => {
    api.rerender('bdaf930a', render)
  })

}


export default __exports__